import { Link } from "react-router-dom";
import { hotTopics } from "@/mocks/topics";
import StatusBadge from "@/components/feature/StatusBadge";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function ReversalTimeline() {
  const list = hotTopics.slice(0, 4);

  return (
    <section className="w-full bg-accent-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="反转与辟谣专区"
          title="那些被推翻的说法"
          desc="有些瓜刚出来时的主流说法，其实站不住。这里集中列出已经发生反转或完成辟谣的事件。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <ol className="relative border-l-2 border-accent-200 pl-6 md:pl-8">
              {list.map((topic, index) => (
                <Reveal key={topic.id} delay={index * 70}>
                  <li className="relative pb-8 last:pb-0">
                    <span
                      className={`absolute -left-[31px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 md:-left-[39px] ${
                        topic.status === "反转"
                          ? "border-accent-500 bg-accent-500 text-foreground-950"
                          : "border-background-300 bg-background-50 text-foreground-500"
                      }`}
                    >
                      <i className="text-[10px] ri-refresh-line" aria-hidden="true"></i>
                    </span>
                    <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                      <span className="font-medium text-accent-700">{topic.date}</span>
                      <StatusBadge status={topic.status} />
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                      <Link
                        to={`/topics/${topic.id}`}
                        className="cursor-pointer transition-colors hover:text-primary-600"
                      >
                        {topic.title}
                      </Link>
                    </h3>
                    <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                      {topic.keyPoints[0]}
                    </p>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>

          <Reveal delay={120} className="lg:col-span-4">
            <div className="h-full rounded-lg border border-accent-200 bg-background-50 p-5 md:p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-xl text-accent-700">
                <i className="ri-question-line" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                为什么反转这么常见？
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                信息在传播中被不断压缩与再解读，最初流传的版本往往已经偏离原始材料。等到完整材料出现，被广泛接受的结论就可能被推翻。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                所以我们坚持先看材料再下判断——晚一点没关系，站不住才麻烦。
              </p>
              <Link
                to="/faq"
                className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
              >
                查看常见问题
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}